import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'

Vue.use(Router)

const router =  new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            meta: {
                title: 'UIPack'
            },
            component: () => import('./views/Home.vue')
        },
        {
            path: '/news',
            name: 'news',
            meta: {
                title: 'UIPack - 新聞'
            },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/News.vue')
        },
        {
            path: '/downloads',
            name: 'downloads',
            meta: {
                title: 'UIPack - 下載'
            },
            component: () => import(/* webpackChunkName: "about" */ './views/Downloads.vue')
        },
        {
            path: '/about',
            name: 'about',
            meta: {
                title: 'UIPack - 關於'
            },
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/desert/',
            name: 'desert',
            meta: {
                title: 'UIPack - Desert'
            },
            component: () => import('./views/Desert.vue')
        },
        {
            name: '404',
            path: '/404',
            component: () => import('./views/404.vue')
        },
        {
            path: '*',
            component: () => import('./views/404.vue')
        }
    ],
    // scroll controller
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

Vue.use(VueAnalytics, {
    id: 'UA-110602034-8',
    router
})

export default router